import CategoryItem from "../CategoryItem";
import styles from "./styles.module.css"

import { useState, useEffect, useMemo } from "react";

import { database } from "../../../services/firebase-config";

import { getDocs, collection } from "firebase/firestore";
import CategoryCreateButton from "../CategoryCreateButton";


import DataTable from 'react-data-table-component';

export default function ListQuestions() {

    let count = 0;

    const [categories, setCategories] = useState([]);
    const categoriesCollectionRef = collection(database, 'categories');
    const [updateTable, setUpdateTable] = useState(1);





    function updateTableData() {
        setUpdateTable(updateTable + 1);
        console.log('updateFirebaseData');
    }


    useEffect(() => {
        const getCategories = async () => {
            const data = await getDocs(categoriesCollectionRef);
            setCategories(data.docs.map((doc) => ({ ...doc.data(), id: doc.id })))
            console.log('getFirebaseData');
        }
        getCategories();
    }, [updateTable]);


    const columns = [
        {
            name: 'Categorias',
            selector: row => row.name,
            sortable: true,
        },
        {
            name: 'Ativo',
            selector: row => row.active,
        },
        {
            name: '  ',
            selector: row => row.options,
            style: {
                justifyContent: 'flex-end'
            }
        },
    ];



    const paginationComponentOptions = {
        rowsPerPageText: 'Categorias por pagina',
        rangeSeparatorText: 'de',
        selectAllRowsItem: true,
        selectAllRowsItemText: 'Todos',
    };


    const [filterText, setFilterText] = useState('');
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
    const filteredItems = categories.filter(
        ebook => ebook.name && ebook.name.toLowerCase().includes(filterText.toLowerCase()),
    );

    const data = filteredItems.map((category) => {
        return {
            name: category.name,
            active: category.active ? 'Ativado' : 'Desativado',
            options: <CategoryItem key={category.id} collectionRef={categoriesCollectionRef} count={count++} categoryData={category} updateTableData={updateTableData} />

        }
    });

    const subHeaderComponentMemo = useMemo(() => {
        const handleClear = () => {
            if (filterText) {
                setResetPaginationToggle(!resetPaginationToggle);
                setFilterText('');
            }
        };

        return (
            <div className={styles.filterTable}>
                <label htmlFor="filtro">Buscar: </label>
                <input id='filtro' name='filtro' placeholder='Nome da categoria...' onChange={e => setFilterText(e.target.value)} value={filterText} />
            </div>

        );
    }, [filterText, resetPaginationToggle]);

    return (
        <div className={styles.ListContainer}>

            <div className={styles.ControlsContainer}>
                <CategoryCreateButton updateTableData={updateTableData} collectionRef={categoriesCollectionRef} />
                {subHeaderComponentMemo}
            </div>

            <DataTable
                title="Categorias"
                pagination
                paginationComponentOptions={paginationComponentOptions}
                noDataComponent="Nenhuma categoria encontrada"
                columns={columns}
                data={data} />

        </div>
    );
}